/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./cp-init.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./cp-init.component";
var styles_CpInitComponent = [i0.styles];
var RenderType_CpInitComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_CpInitComponent, data: {} });
export { RenderType_CpInitComponent as RenderType_CpInitComponent };
export function View_CpInitComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 0, "p", [], null, null, null, null, null))], null, null); }
export function View_CpInitComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-cp-init", [], null, null, null, View_CpInitComponent_0, RenderType_CpInitComponent)), i1.ɵdid(1, 114688, null, 0, i2.CpInitComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CpInitComponentNgFactory = i1.ɵccf("app-cp-init", i2.CpInitComponent, View_CpInitComponent_Host_0, {}, {}, []);
export { CpInitComponentNgFactory as CpInitComponentNgFactory };
